<aup-empty-state>
  <aup-markdown [content]="this.i18n.message()"></aup-markdown>
</aup-empty-state>
